// extracted by mini-css-extract-plugin
export var completionBody = "_cs-2";
export var completionCard = "_cs-0";
export var completionFooter = "_cs-3";
export var completionTitle = "_cs-1";